import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

//components
import {
  QuestionCheckboxes,
  Text,
  ExpandablePillTextField,
  Button,
  Unless,
  If,
} from './..'

//styling
import styles from './MultiSelect.module.scss'

//constants
import { PREQUAL_TOPIC_KEY } from '../../constants/directMessages'
import { HIDDEN } from '../../constants/multiSelect'

const MultiSelect = ({
  onCustomQuestionChange,
  updateSelectedQuestions,
  setPrequalSelected,
  onSubmit,
  error,
  loadingSpin,
  className,
  buttonLabel,
  questions,
  customQuestionMessage,
  multiSelectDisabled,
}) => {
  const displayRef = useRef()
  const [selectedKeys, setSelectedKeys] = useState([])

  const handleSelectQuestions = topicKey => {
    const found = selectedKeys.includes(topicKey)

    if (found) {
      const selectedKeysCopy = [...selectedKeys]
      const newSelectedKeys = selectedKeysCopy.filter(key => key !== topicKey)
      setSelectedKeys(newSelectedKeys)
    } else {
      setSelectedKeys(selectedKeys => [...selectedKeys, topicKey])
    }
  }

  useEffect(() => {
    if (selectedKeys) {
      if (selectedKeys.length >= 0) {
        const selectedQuestions = selectedKeys.map(selectedQuestionKey => {
          const selectedQuestion = questions.find(
            q => q.topicKey === selectedQuestionKey
          )
          return selectedQuestion
        })

        updateSelectedQuestions(selectedQuestions)
      }
    }
  }, [selectedKeys, questions, updateSelectedQuestions])

  useEffect(() => {
    if (selectedKeys) {
      const prequalFound = selectedKeys.includes(PREQUAL_TOPIC_KEY)
      if (prequalFound) {
        setPrequalSelected(true)
      } else {
        setPrequalSelected(false)
      }
    }
  }, [selectedKeys, setPrequalSelected])

  //resets qustions on drawer close
  useEffect(() => {
    if (
      displayRef.current &&
      selectedKeys.length &&
      window.getComputedStyle(displayRef?.current).visibility === HIDDEN
    ) {
      setSelectedKeys([])
    }
  })

  const customIsFilled = customQuestionMessage && customQuestionMessage.length

  return (
    <div ref={displayRef} className={classnames(styles.multiSelect, className)}>
      <div className={styles.questionHeaderContainer}>
        <Text className={styles.questionHeader}>
          Select As Many As You'd Like
        </Text>
      </div>
      <QuestionCheckboxes
        onClick={handleSelectQuestions}
        questions={questions}
        selectedKeys={selectedKeys}
      />
      <div
        className={classnames(
          styles.questionCheckboxContainer,
          styles.fullWidth
        )}
      >
        <ExpandablePillTextField
          className={customIsFilled && styles.filled}
          name='Custom Question'
          onChange={onCustomQuestionChange}
          value={customQuestionMessage}
          maxRows={2}
        />
      </div>
      <div className={styles.submitContainer}>
        <Unless condition={error}>
          <Button
            primary={!multiSelectDisabled}
            onClick={onSubmit}
            disabled={multiSelectDisabled}
            children={buttonLabel}
            fullWidth={true}
            loading={loadingSpin}
          />
        </Unless>
        <If condition={error}>
          <Text>Something went wrong.</Text>
          <div onClick={onSubmit}>
            <Text className={styles.retrySubmit}>Retry Sending?</Text>
          </div>
        </If>
      </div>
    </div>
  )
}

MultiSelect.propTypes = {
  onCustomQuestionChange: PropTypes.func,
  updateSelectedQuestions: PropTypes.func,
  setPrequalSelected: PropTypes.func,
  onSubmit: PropTypes.func,
  selectedKeys: PropTypes.array,
  questions: PropTypes.array,
  className: PropTypes.string,
  customQuestionMessage: PropTypes.string,
  buttonLabel: PropTypes.string,
  multiSelectDisabled: PropTypes.bool,
  loadingSpin: PropTypes.bool,
  error: PropTypes.bool,
}

export default MultiSelect
